import * as serviceWorker from "./serviceWorker";

import React from "react";
import { Provider } from "react-redux";
import store from "./services/store";

// import InAppNotification from "./components/Mobile/InAppNotification";
import PWAPrompt from "react-ios-pwa-prompt";
import CustomCssProvider from "./components/CustomCssProvider";

export const tenant = "eatiko";
const Root = ({ children, initialState = {} }) => (
  <React.Fragment>
    <Provider store={store(initialState)}>
      <CustomCssProvider />
      {children}
      <img
        className='cart-empty-img hidden'
        src='/assets/img/various/offline.png'
        alt='offline'
      />
      {/* <InAppNotification /> */}
      {/* <CheckVersion /> */}
      {localStorage.getItem("enIOSPWAPopup") === "true" && (
        <PWAPrompt
          delay={2500}
          copyTitle={localStorage.getItem("iOSPWAPopupTitle")}
          copyBody={localStorage.getItem("iOSPWAPopupBody")}
          copyShareButtonLabel={localStorage.getItem(
            "iOSPWAPopupShareButtonLabel"
          )}
          copyAddHomeButtonLabel={localStorage.getItem(
            "iOSPWAPopupAddButtonLabel"
          )}
          copyClosePrompt={localStorage.getItem("iOSPWAPopupCloseButtonLabel")}
        />
      )}
    </Provider>
  </React.Fragment>
);

serviceWorker.register();

export default Root;
